export default __webpack_public_path__ + "static/media/02_DAIF_Services_03_end.7f16ad82.jpg";